/**
 * Schema builder utilities
 * Reusable JSON schema builders for DRY principle
 */

/**
 * Create a string field schema
 */
export function stringField(description: string, options?: { minLength?: number; maxLength?: number }) {
  return {
    type: 'string',
    description,
    ...(options?.minLength && { minLength: options.minLength }),
    ...(options?.maxLength && { maxLength: options.maxLength }),
  };
}

/**
 * Create a number field schema
 */
export function numberField(description: string, options?: { minimum?: number; maximum?: number }) {
  return {
    type: 'number',
    description,
    ...(options?.minimum !== undefined && { minimum: options.minimum }),
    ...(options?.maximum !== undefined && { maximum: options.maximum }),
  };
}

/**
 * Create a boolean field schema
 */
export function booleanField(description: string) {
  return {
    type: 'boolean',
    description,
  };
}

/**
 * Create an array field schema
 */
export function arrayField(description: string, itemType: any) {
  return {
    type: 'array',
    description,
    items: itemType,
  };
}

/**
 * Create an object field schema
 */
export function objectField(description: string, properties?: Record<string, any>) {
  return {
    type: 'object',
    description,
    ...(properties && { properties }),
  };
}

/**
 * Create an enum field schema
 */
export function enumField(description: string, values: string[]) {
  return {
    type: 'string',
    enum: values,
    description,
  };
}

/**
 * Create a UUID field schema
 */
export function uuidField(description: string) {
  return stringField(description, { minLength: 36, maxLength: 36 });
}

/**
 * Create an ISO timestamp field schema
 */
export function timestampField(description: string) {
  return stringField(description);
}
